var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.661111 0C0.29599 0 0 0.298477 0 0.666667V13.3333C0 14.0697 0.591979 14.6667 1.32222 14.6667H13.8833C14.2485 14.6667 14.5444 14.3682 14.5444 14C14.5444 13.6318 14.2485 13.3333 13.8833 13.3333L1.98333 13.3333C1.61821 13.3333 1.32222 13.0349 1.32222 12.6667V0.666667C1.32222 0.298477 1.02623 0 0.661111 0Z",
    fill: "#0057C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30556 8.66667C3.30556 8.29848 3.60154 8 3.96667 8C4.33179 8 4.62778 8.29848 4.62778 8.66667V10.6667C4.62778 11.0349 4.33179 11.3333 3.96667 11.3333C3.60154 11.3333 3.30556 11.0349 3.30556 10.6667V8.66667Z",
    fill: "#0057C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61111 6C6.24599 6 5.95 6.29848 5.95 6.66667V10.6667C5.95 11.0349 6.24599 11.3333 6.61111 11.3333C6.97623 11.3333 7.27222 11.0349 7.27222 10.6667V6.66667C7.27222 6.29848 6.97623 6 6.61111 6Z",
    fill: "#0057C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59444 4.66667C8.59444 4.29848 8.89043 4 9.25556 4C9.62068 4 9.91667 4.29848 9.91667 4.66667V10.6667C9.91667 11.0349 9.62068 11.3333 9.25556 11.3333C8.89043 11.3333 8.59444 11.0349 8.59444 10.6667V4.66667Z",
    fill: "#0057C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 2C11.5349 2 11.2389 2.29848 11.2389 2.66667V10.6667C11.2389 11.0349 11.5349 11.3333 11.9 11.3333C12.2651 11.3333 12.5611 11.0349 12.5611 10.6667V2.66667C12.5611 2.29848 12.2651 2 11.9 2Z",
    fill: "#0057C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.10a349f5.svg";
export { ForwardRef as ReactComponent };